import { TidewaysContext } from '../../app/context'
import { Entity } from '../../app/entity'
import { GraphEntity } from '../../domain/GraphEntity'
import { MonitorOperation } from '../../domain/Operation'
import { ProfileCriteria } from '../../domain/ProfileCriteria'
import { Report } from '../../domain/Report'
import { TraceList } from '../../domain/TraceSummary'
import { ApplicationState } from '../ApplicationState'
import TimeRange from '../../app/timeRange'

export interface MonitorState {
    profiles: Entity<MyProfilesEntity> | null
    graph: { [serviceEnvironment: string]: { [timeRange: string]: Entity<GraphEntity> } }
    baseServiceHistory: { [application: string]: Entity<Report<any>> }
    operations: Entity<MonitorOperationsEntity> | null
}

export interface MyProfilesEntity {
    tidewaysContext: TidewaysContext
    criteria: ProfileCriteria
    profiles: TraceList
}

interface MonitorOperationsEntity {
    critical: { operations: MonitorOperation[] }
}

export const monitorServiceEnvironmentKey = (environment: string, service: string): string => `${environment}::${service}`

export const getMonitorGraph = (
    globalState: ApplicationState,
    service?: string,
    isExternalService: boolean = false,
): Entity<GraphEntity> => {
    const { tidewaysContext } = globalState
    const cacheKey = TimeRange.fromParameters(tidewaysContext.route.parameters).getCacheKey()
    let serviceEnvironment = monitorServiceEnvironmentKey(tidewaysContext.environment, service || tidewaysContext.service)

    if (isExternalService) {
        serviceEnvironment += '[external]'
    }

    return serviceEnvironment in globalState.monitor.graph && cacheKey in globalState.monitor.graph[serviceEnvironment]
        ? globalState.monitor.graph[serviceEnvironment][cacheKey]
        : new Entity()
}
